{
  "error-unable-to-update-email-signature": "Unable to update email signature. Please try again later",
  "error-unable-to-update-email-notification-settings": "Unable to update your email notification settings. Please try again later.",
  "error-email-notification-settings-conflict": "Your email notification settings were updated elsewhere. We've refreshed them. Please try again."
}
